import MultiVpc from "./MultiVpc.vue"

export default MultiVpc
